



















import { Component, Vue, Prop } from "vue-property-decorator";
import { InvoiceModel } from "../models";
import dateFlip from "shared/filters/dateflip";
import money from "shared/filters/money";

@Component({
  filters: {
    dateFlip,
    money
  }
})
export default class InvoiceTable extends Vue {
  @Prop({ required: true })
  invoices!: InvoiceModel[];

  headers = [
    { text: this.t("invoiceID"), value: "invoice_id" },
    { text: this.t("invoiceDate"), value: "invoice_date" },
    { text: this.t("expirationDate"), value: "expiration_date" },
    { text: this.t("amount"), value: "amount" },
    { text: this.t("outstanding"), value: "outstanding" },
    { text: this.t("download"), value: "invoice_id", sortable: false }
  ];

  pagination = {
    rowsPerPage: 15,
    sortBy: "invoice_date",
    descending: true
  };

  rowsPerPageItems = [
    5,
    15,
    25,
    { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
  ];

  private t(key: string): string {
    return this.$t("invoices.table." + key).toString();
  }
}
